import { merge } from "lodash";
const convertDotSeparatedKeyToObject = (key, value) => {
    return key.split(".").reduceRight((bal, curr) => {
        return {
            [curr]: bal
        };
    }, value);
};
export const convertPreferencesToObject = (prefs) => {
    let newObject = {};
    for (const key in prefs) {
        newObject = merge(newObject, convertDotSeparatedKeyToObject(key, prefs[key]));
    }
    return newObject;
};
